import { Divider } from "@mui/material"
import { Footer } from "components/Footer/Footer"
import Header from "components/Header/Header"
import { JSX } from "react"
import { Outlet } from "react-router-dom"

const BaseLayout = (): JSX.Element => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100vh",
      }}
    >
      <header style={{ flex: "0 0 auto" }}>
        <Header />
      </header>
      <main
        style={{
          flex: "1 1 auto",
          overflowY: "auto",
          margin: "0.5em",
        }}
      >
        <Outlet />
      </main>
      <footer style={{ flex: "0 0 auto" }}>
        <Divider />
        <Footer />
      </footer>
    </div>
  )
}

export default BaseLayout
